import authRoutes from "./auth";
import emailListRoutes from "./email-list";
import reviewsRoutes from "./reviews";
import servicesRoutes from "./services";
// import freepikRoutes from "./freepik";
// import homepageRoutes from "./homepage";
import ordersRoutes from "./orders";
// import subscriptionsRoutes from "./subscriptions";
// import patchesRoutes from "./patches";
// import analyticsRoutes from "./analytics";
import userRoutes from "./users";
import tasksRoutes from "./tasks";
import notesRoutes from "./notes";
import notificationRoutes from "./notifications";
import projectRoutes from "./projects";
import categoriesRoutes from "./categories";
import billingRoutes from "./billing";

export default {
  "auth": authRoutes,
  "email-list": emailListRoutes,
  "services": servicesRoutes,
  "reviews": reviewsRoutes,
  "notes": notesRoutes,
  // freepik: freepikRoutes,
  // homepage: homepageRoutes,
  "orders": ordersRoutes,
  // subscriptions: subscriptionsRoutes,
  // patches: patchesRoutes,
  // analytics: analyticsRoutes,
  "categories": categoriesRoutes,
  "users": userRoutes,
  "tasks": tasksRoutes,
  "notifications": notificationRoutes,
  "projects": projectRoutes,
  "billing": billingRoutes,
};
